import { Link } from "react-router-dom";
import { ChevronRight } from "lucide-react";
import { Header } from "@/components/layout/Header";
import { Footer } from "@/components/layout/Footer";
import { WhatsAppFloat } from "@/components/layout/WhatsAppFloat";

export const Breadcrumbs = ({ items = [] }) => (
  <nav aria-label="Breadcrumb" className="text-xs text-spice-subtle" data-testid="breadcrumbs">
    <ol className="flex flex-wrap items-center gap-1.5">
      <li>
        <Link to="/" className="hover:text-spice-green transition-colors" data-testid="breadcrumb-home">
          Home
        </Link>
      </li>
      {items.map((item, i) => (
        <li key={item.label} className="flex items-center gap-1.5">
          <ChevronRight className="w-3 h-3 text-spice-line" aria-hidden="true" />
          {i === items.length - 1 || !item.to ? (
            <span className="text-spice-ink font-medium" aria-current="page">{item.label}</span>
          ) : (
            <Link to={item.to} className="hover:text-spice-green transition-colors">{item.label}</Link>
          )}
        </li>
      ))}
    </ol>
  </nav>
);

export const PageShell = ({ title, subtitle, breadcrumbs = [], children, testid = "page" }) => (
  <div className="min-h-screen bg-spice-cream flex flex-col" data-testid={testid}>
    <Header />
    <main className="flex-1">
      <section className="bg-spice-green-dark text-white px-4 sm:px-6 py-12 sm:py-16">
        <div className="max-w-5xl mx-auto space-y-4">
          <div className="[&_a]:text-spice-sage [&_span]:text-white text-spice-sage">
            <Breadcrumbs items={breadcrumbs} />
          </div>
          <h1 className="text-3xl sm:text-4xl font-extrabold tracking-tight" data-testid="page-title">{title}</h1>
          {subtitle && <p className="text-sm sm:text-base text-spice-mist max-w-3xl leading-relaxed">{subtitle}</p>}
        </div>
      </section>
      {children}
    </main>
    <Footer />
    <WhatsAppFloat />
  </div>
);
